 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTML00_HALF_TIT from '@/components/html/00_Half_tit'
 import HTML01_TITLE_PA from '@/components/html/01_Title_pa'
 import HTMLNOTICE from '@/components/html/notice'
 import HTML03_FMT from '@/components/html/03_Fmt'
 import HTML04_CONTENTS from '@/components/html/04_Contents'
 import HTML05_PROLOGUE from '@/components/html/05_PROLOGUE'
 import HTML06_CHAPTER from '@/components/html/06_CHAPTER'
 import HTML07_RANDOLPH from '@/components/html/07_Randolph'
 import HTML08_CHAPTER from '@/components/html/08_CHAPTER'
 import HTML09_EARLY_SI from '@/components/html/09_Early_Si'
 import HTML10_CHAPTER from '@/components/html/10_CHAPTER'
 import HTML11_DAWN_REC from '@/components/html/11_Dawn_Rec'
 import HTML12_CHAPTER from '@/components/html/12_CHAPTER'
 import HTML13_PUTTING from '@/components/html/13_Putting'
 import HTML14_CHAPTER from '@/components/html/14_CHAPTER'
 import HTML15_WELCOME from '@/components/html/15_Welcome'
 import HTML16_EPILOGUE from '@/components/html/16_EPILOGUE'
 import HTML17_DEDICATI from '@/components/html/17_Dedicati'
 import HTML18_ACKNOWLE from '@/components/html/18_Acknowle'
 import HTML19_NOTES from '@/components/html/19_Notes'
 import HTML20_INDEX from '@/components/html/20_Index'
 import HTML02_COPYRIGH from '@/components/html/02_Copyrigh'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_Contents",
 			"name" : "html/04_Contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_PROLOGUE",
 			"name" : "html/05_PROLOGUE",
 			"component" : HTML05_PROLOGUE
 		},
 		{
 			"path" : "/html/06_CHAPTER",
 			"name" : "html/06_CHAPTER",
 			"component" : HTML06_CHAPTER
 		},
 		{
 			"path" : "/html/07_Randolph",
 			"name" : "html/07_Randolph",
 			"component" : HTML07_RANDOLPH
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js